import { IconSparkles } from '@tabler/icons-react'
import { IconButton, SvgIcon, Tooltip } from '@mui/material'
import { useState } from 'react'
import { AgentDrawer } from './AgentDrawer'

export const AgentButton = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Tooltip title="Ask the assistant" placement="left">
        <IconButton
          onClick={() => setOpen(true)}
          color="primary"
          sx={{
            flexShrink: 0,
            color: (t) => t.palette.getContrastText(t.palette.primary.main),
            backgroundColor: (t) => t.palette.secondary.main,
            '&:hover': {
              backgroundColor: (t) => t.palette.primary.light,
            },
          }}
        >
          <SvgIcon fontSize="small">
            <IconSparkles stroke={1.5} />
          </SvgIcon>
        </IconButton>
      </Tooltip>
      <AgentDrawer open={open} onClose={() => setOpen(false)} />
    </>
  )
}
